let normal;

import _ from 'lodash';
import React from 'react';
import type { SystemDictionary } from 'tm3-core/api.dtos';
import { cache } from 'tm3-core/cache';

const matchFirstLetterCasing = function (newWord, word) {
  if (word[0] === word[0].toUpperCase()) {
    newWord = newWord[0].toUpperCase() + newWord.substring(1);
  } else if (word[0] === word[0].toLowerCase()) {
    newWord = newWord[0].toLowerCase() + newWord.substring(1);
  }
  return newWord;
};
export function unword(word: string) {
  const configDictionary = cache.dictionary;
  return (
    Object.keys(configDictionary).find((k) => configDictionary[k].value?.toLowerCase() === word) ??
    word
  );
}
function word(word: string, count = 0, possessive = false) {
  const configDictionary = cache.dictionary;
  if (!word) return word;
  if (word.toLowerCase() === 'customer') word = matchFirstLetterCasing('patient', word);
  let returnWord: SystemDictionary = configDictionary[word.toLowerCase()];
  if (!returnWord) {
    for (let key in configDictionary) {
      if (word.toLowerCase().indexOf(key) === 0) {
        returnWord = configDictionary[key];
        if (_.isObject(returnWord)) {
          return matchFirstLetterCasing(
            (count > 1 ? returnWord.plural : returnWord.value) + word.substring(key.length),
            word
          );
        }
        break;
      }
    }
  }
  if (_.isObject(returnWord)) {
    if (word === 'VAT') {
      const location = (cache.config.LOCATION as string)?.toLowerCase();
      return returnWord[location] ?? word;
    } else {
      return matchFirstLetterCasing(
        count > 1 ? (returnWord.plural ?? pluralise(returnWord.value)) : returnWord.value,
        word
      );
    }
  } else if (returnWord) {
    return matchFirstLetterCasing(returnWord, word);
  }
  if (count <= 1) return word;

  return pluralise(word);
}

function pluralise(word: string) {
  const lastLetter = word.toLowerCase().charAt(word.length - 1);
  const lastLetters = word.toLowerCase().substring(word.length - 2);
  const suffix =
    ['s', 'x', 'z'].includes(lastLetter) || ['sh', 'ch'].includes(lastLetters) ? 'es' : 's';

  return word + suffix;
}

function format(str: string, number: number = 0) {
  if (!!str && !str?.includes('{')) {
    return word(str, number);
  }
  return (str || '').replace(/\{(.*?)\}/g, (x) =>
    word(x.replace('{', '').replace('}', ''), number)
  );
}

function replacePlainText(str: string, capitalize?: boolean) {
  var zedifiedStr = str
    .replace(/(client|patient|customer)/gim, `${word('patient')}`)
    .replace(/(practitioner)/gim, `${word('practitioner')}`)
    .replace(/(room)/gim, `${word('room')}`)
    .replace(/(practice)/gim, `${word('practice')}`);
  return capitalize ? _.startCase(zedifiedStr) : zedifiedStr;
}

function setApplication(app) {
  const configDictionary = cache.dictionary;
  configDictionary.tm3 = app;
}

// I don't think these are used - remove?
export class Patient extends React.Component {
  render() {
    const mode = cache.config.TM3MODE;
    if ((mode != null ? mode.toUpperCase() : undefined) === 'TRUE') {
      return (
        <LingoWord
          {...this.props}
          Normal="Client"
          NormalPlural="Clients"
          Possessive="Client's"
          PossessivePlural="Clients'"
        />
      );
    } else {
      return (
        <LingoWord
          {...this.props}
          Normal="Patient"
          NormalPlural="Patients"
          Possessive="Patient's"
          PossessivePlural="Patients'"
        />
      );
    }
  }
}
export class Practitioner extends React.Component {
  render() {
    return (
      <LingoWord
        {...this.props}
        Normal="Practitioner"
        NormalPlural="Practitioners"
        Possessive="Practitioner's"
        PossessivePlural="Practitioners'"
      />
    );
  }
}
export class Contact extends React.Component {
  render() {
    return (
      <LingoWord
        {...this.props}
        Normal="Contact"
        NormalPlural="Contact"
        Possessive="Contact's"
        PossessivePlural="Contact'"
      />
    );
  }
}

export class Business extends React.Component {
  render() {
    const mode = cache.config.TM3MODE;
    if ((mode != null ? mode.toUpperCase() : undefined) === 'TRUE') {
      return (
        <LingoWord
          {...this.props}
          Normal="Business"
          NormalPlural="Business"
          Possessive="Business's"
          PossessivePlural="Businesses'"
        />
      );
    } else {
      return (
        <LingoWord
          {...this.props}
          Normal="Group"
          NormalPlural="Groups"
          Possessive="Groups's"
          PossessivePlural="Groups'"
        />
      );
    }
  }
}
export default {
  Contact,
  Business,
  Patient,
  Practitioner,
  word,
  format,
  setApplication,
  replacePlainText
};
export { word, format, setApplication, replacePlainText };

class LingoWord extends React.Component {
  static defaultProps = {
    count: 1,
    own: false,
    lower: false,
    Normal: '',
    NormalPlural: '',
    Possessive: '',
    PossessivePlural: ''
  };

  render() {
    let word;
    if (this.props.own) {
      if (this.props.count === 1) {
        word = this.props.PossessivePlural || this.props.Possessive || this.props.Normal;
      }
      if (this.props.count !== 1) {
        word = this.props.Possessive;
      }
    } else {
      if (this.props.count === 1) {
        word = this.props.Normal;
      }
      if (this.props.count !== 1) {
        word = this.props.NormalPlural || this.props.Normal;
      }
    }
    if (this.props.lower) {
      word = word.toLowerCase();
    }
    return <span>{word} </span>;
  }
}
